import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Welcome from './Welcome';
import EmployerSignUpPage from '../components/SignUp/EmployerSignUpPage';
import StudentSignUpPage from '../components/SignUp/StudentSignUpPage';

const SignUpPage = () => {

    const [userType, setUserType] = useState("jobSeeker");
    const [serverError, setServerError] = useState("");

    const handleUserTypeChange = (type) => {
        setUserType(type);
    }; 
    
    const handleServerError = (error) => {
        setServerError(error);
    }; 

    const showToast = (message, type = "success") => {
      toast[type](message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: `custom-toast custom-toast-${type}`,
        bodyClassName: "custom-toast-body",
        progressClassName: "custom-toast-progress",
      });
    };

  return (
    <div className="auth-background">
      <ToastContainer />
      <div className="left-section">
        <Welcome />
      </div>
      <div className="right-section">
        <div className="signup-card">
          <h2 className='auth-name'>Sign Up</h2>
          {serverError && <div className="error server-error">{serverError}</div>}
          {userType === "employer" && <p>Create an account to post jobs and find talented candidates</p>}
          {userType === "jobSeeker" && <p>Create an account to access the latest sales internships, networking, events & training</p>}
          <div className="user-type-switch">
              <button 
                className={userType === "employer" ? "active" : ""}
                onClick={() => handleUserTypeChange("employer")}
              >
                Employer
              </button>
              <button 
                className={userType === "jobSeeker" ? "active" : ""}
                onClick={() => handleUserTypeChange("jobSeeker")}
              >
                Intern
              </button>
            </div>
            {userType === "employer" && <EmployerSignUpPage handleServerError={handleServerError} showToast={showToast}/>}
            {userType === "jobSeeker" && <StudentSignUpPage handleServerError={handleServerError} showToast={showToast}/>}
            <p className="links">
            Already have an account? <Link to="/signin" className="signinlink"><strong>Sign In</strong></Link>
          </p>
          </div>
      </div>
    </div>
  )
}

export default SignUpPage
